import { Component, Input, ViewChild } from '@angular/core';
import { Slides} from 'ionic-angular';


/**
 * Generated class for the UploadsUploadFormComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'adf-stepper',
  template: `<div class="steps">
  <ul class="customPagination scrolling-wrapper">
      <li class="card" *ngFor="let item of itemList;let i=index " (click)="slideNum(i);">
          <span class="steps">
              <ion-icon name="close-circle" *ngIf="!item.isValid"></ion-icon>
              <ion-icon name="checkmark"  *ngIf="item.isValid"></ion-icon>
              {{item.name}}
          </span>
      </li>
      
  </ul>
</div>

<ion-slides #stepperSlider (ionSlideDidChange)="slideChanged()">
    <ion-slide *ngFor="let item of itemList">
      <div class="first_asset_sec firstSlideForm">
      {{item.name}}
      </div>
    </ion-slide>

`
})
export class Stepper{

  @Input() itemList: any;
  @ViewChild(Slides) stepperSlider: Slides;


  constructor() {
    console.log(this.itemList);
  }
  ngOnInit() {
    this.stepperSlider.autoHeight = true;
  }
  ngAfterViewInit(){
    this.stepperSlider.lockSwipes(true);

  }
  public slideNum(num){
    this.stepperSlider.lockSwipes(false);
    this.stepperSlider.slideTo(num);
    this.stepperSlider.lockSwipes(true);
  }

  slideChanged() {
    //let currentIndex = this.signupSlider.getActiveIndex();
  }

}



// WEBPACK FOOTER //
// ./src/pages/adf-page/component/stepper/stepper.ts